"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendBookSrcToBookingUrl = exports.appendApptInfoToBookingUrl = void 0;
const qs_1 = __importDefault(require("qs"));
const appendApptInfoToBookingUrl = (apptInfo, bookOnlineUrl) => {
    const [baseBookingUrl, bookingQuery] = bookOnlineUrl.split('?');
    const bookingParams = qs_1.default.parse(bookingQuery);
    if (apptInfo != null) {
        const { relationship, purpose } = apptInfo;
        if (relationship) {
            bookingParams.relationship = relationship;
        }
        if (purpose) {
            bookingParams.purpose = purpose;
        }
    }
    const combinedQuery = qs_1.default.stringify(bookingParams);
    return `${baseBookingUrl}?${combinedQuery}`;
};
exports.appendApptInfoToBookingUrl = appendApptInfoToBookingUrl;
const appendBookSrcToBookingUrl = (url, bookSrc) => {
    if (bookSrc) {
        if (url.includes('?')) {
            url += `&book_src=${bookSrc}`;
        }
        else {
            url += `?book_src=${bookSrc}`;
        }
    }
    return url;
};
exports.appendBookSrcToBookingUrl = appendBookSrcToBookingUrl;
//# sourceMappingURL=availability.js.map